angular.module('impactx.productlabel').controller('ProductLabelIconsCtrl', [
    '$element',
    'ProductLabel',
    ProductLabelIconsController
]);

function ProductLabelIconsController($element, ProductLabel) {
    var self = this;

    self.openProductLabelDialog = function (event, productLabel) {
        ProductLabel.openInfoText(event, productLabel.id);
    };
}